<template>
  <div class="list-view product-checkout">

    <b-row>
      <b-col
        cols="12"
        md="8"
      >
        <!-- Left Card -->
        <b-card no-body>
          <b-card-header class="flex-column align-items-start">
            <b-card-title>Opciones de pago</b-card-title>
            <b-card-text class="text-muted mt-25">
              Asegúrate de seleccionar la opción de pago correcta antes de continuar.
            </b-card-text>
          </b-card-header>
          <b-card-body>

            <hr class="mb-2 mt-1">
            <div ref="wompiButtonContainer" />

          </b-card-body>
        </b-card>
      </b-col>
      <b-col
        cols="12"
        md="4"
      >
        <!-- Right Card -->

        <div class="checkout-options">
          <b-card>

            <label class="section-label mb-1">Detalle</label>

            <hr>
            <div class="price-details">
              <!--                <h6 class="price-title">
                  Price Details
                </h6>-->

<!--              <b-media
                class="mb-1"
                no-body
              >
                <b-media-body>
                  <p class="mb-0">
                    Alineadores Superiores
                  </p>
                  <small>Cant. 1</small>
                </b-media-body>

                <div>
                  <p class="mb-0">
                    $60.000
                  </p>
                </div>
              </b-media>-->



              <detail-payment-checkout :payment-details="paymentDetails"/>

            </div>

          </b-card>
        </div>

        <div class="customer-card">
          <!-- Left Form -->
          <b-card>

            <label class="section-label mb-1">Dirección de entrega</label>

            <hr>
            <b-card :title="addressDetails.clinic_name">
              <b-card-text class="mb-0">
                {{ addressDetails.address }}
              </b-card-text>
              <b-card-text>{{ addressDetails.city }}, {{ addressDetails.department }}</b-card-text>
              <hr>
              <label class="section-label mb-1">Clínica</label>
              <b-card-text>Celular: {{ addressDetails.clinic_phone }}</b-card-text>
              <b-card-text>WhatsApp: {{ addressDetails.clinic_whatsapp }}</b-card-text>
              <hr>
              <label class="section-label mb-1">Odontologo</label>
              <b-card-text>Nombre: {{ addressDetails.dentist_full_name }}</b-card-text>
              <b-card-text>Celular: {{ addressDetails.dentist_phone }}</b-card-text>
              <b-card-text>Correo: {{ addressDetails.dentist_email }}</b-card-text>
              <!--                <b-button
                                variant="info"
                                @click="$emit('next-step')"
                              >
                                Agregar otra dirección de entrega
                              </b-button>-->
            </b-card>
          </b-card>
        </div>

      </b-col>
    </b-row>

  </div>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardText,
  BCardBody,
  BFormGroup,
  BFormRadio,
  BFormInput,
  BButton,
  BCol,
  BRow,
  BMedia,
  BMediaBody,
} from 'bootstrap-vue'
import api from '@/plugin/axios'
import LoadingSkeleton from '@/views/misc/LoadingSkeleton.vue'
import DetailPaymentCheckout from '@/views/admin/payment/DetailPaymentCheckout.vue'

export default {
  components: {
    DetailPaymentCheckout,
    LoadingSkeleton,
    BMediaBody,
    BMedia,
    BRow,
    BCol,
    // BSV
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BFormGroup,
    BFormRadio,
    BFormInput,
    BButton,
  },
  props: {
    paymentDetails: {
      type: Object,
      required: true,
    },
    addressDetails: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      amount: 0,
      dataPayment: null,
    }
  },
  mounted() {
    this.generatePayment()
    /* const script = document.createElement('script')
    script.src = 'https://checkout.wompi.co/widget.js'
    script.setAttribute('data-render', 'button')
    script.setAttribute('data-public-key', 'pub_test_X0zDA9xoKdePzhd8a0x9HAez7HgGO2fH')
    script.setAttribute('data-currency', 'COP')
    script.setAttribute('data-amount-in-cents', '4950000')
    script.setAttribute('data-reference', '4XMPGKWWPKWQ')
    script.setAttribute('data-signature:integrity', '37c8407747e595535433ef8f6a811d853cd943046624a0ec04662b17bbf33bf5')

    this.$refs.wompiButtonContainer.appendChild(script) */
  },
  methods: {
    async generatePayment() {
      try {
        this.amount = this.paymentDetails.total_cost
        const response = await api.post('/api/payments/wompi/generate-payment-data', {
          amount: this.amount,
          customer_email: this.userData.email,
          planning_order_id: this.$route.params.id,
          aligner_fabrication_id: this.$route.params.fabrication,
          payment_type: this.$route.params.payment_type,
        })

        this.dataPayment = response.data

        const script = document.createElement('script')
        script.src = 'https://checkout.wompi.co/widget.js'
        script.setAttribute('data-render', 'button')
        script.setAttribute('data-public-key', response.data.public_key)
        script.setAttribute('data-currency', 'COP')
        script.setAttribute('data-amount-in-cents', response.data.amount_in_cents)
        script.setAttribute('data-reference', response.data.reference)
        script.setAttribute('data-signature:integrity', response.data.signature)
        script.setAttribute('data-redirect-url', response.data.redirect_url)

        this.$refs.wompiButtonContainer.appendChild(script)
      } catch (error) {
        alert('Error generando el pago')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#cvv {
  width: auto;
}
</style>
